/**
 * BroadcastChannel pour synchroniser le cache entre onglets
 * Plus fiable que l'événement 'storage' natif
 */

// Créer le channel (undefined si pas supporté par le browser)
const channel = typeof BroadcastChannel !== 'undefined' 
  ? new BroadcastChannel('cc:activity')
  : null;

/**
 * Émettre un événement de mise à jour du cache
 * Propage vers tous les onglets ouverts
 * @param {string} topic - Topic du cache mis à jour (ex: 'activity', 'bootstrap')
 */
export function broadcastCacheUpdate(topic) {
  if (channel) {
    channel.postMessage({ 
      type: 'CACHE_UPDATED', 
      topic, 
      at: Date.now() 
    });
    console.log(`📡 [broadcast] Émission cache update: ${topic}`);
  }
  
  // Émettre aussi l'événement DOM classique (pour l'onglet actuel)
  window.dispatchEvent(new CustomEvent('cc:cache-updated', { 
    detail: { topic, at: Date.now() } 
  }));
}

/**
 * Écouter les événements de cache d'autres onglets
 * @param {Function} callback - Callback appelé avec le topic
 * @returns {Function} Fonction de cleanup
 */
export function onBroadcastCacheUpdate(callback) {
  if (!channel) {
    console.warn('[broadcast] BroadcastChannel not supported');
    return () => {};
  }
  
  const handler = (e) => {
    if (e.data?.type === 'CACHE_UPDATED') {
      console.log(`📡 [broadcast] Réception cache update: ${e.data.topic}`);
      callback(e.data.topic);
    }
  };
  
  channel.addEventListener('message', handler);
  
  // Retourner la fonction de cleanup
  return () => {
    channel.removeEventListener('message', handler);
  };
}

/**
 * Fermer le channel (cleanup)
 */
export function closeBroadcastChannel() {
  if (channel) {
    channel.close();
  }
}
